module.exports = __webpack_public_path__ + "static/media/bg-320.214a3ca8.png";